import { formatInTimeZone, zonedTimeToUtc } from "date-fns-tz";

const TIME_ZONE = "Europe/Amsterdam";

/** `?riskPictureNow=2026-12-15`. The name match ignores case. */
export const RISK_PICTURE_NOW_PARAM = "riskPictureNow";

/**
 * Noon in Amsterdam on `raw` (`YYYY-MM-DD`). Anything else, including a date
 * that does not exist, returns `fallback`.
 */
export const riskPictureNowFromParam = (raw: string | null, fallback: Date): Date => {
  if (!raw || !/^\d{4}-\d{2}-\d{2}$/.test(raw)) return fallback;
  const date = zonedTimeToUtc(`${raw}T12:00:00`, TIME_ZONE);
  if (Number.isNaN(date.getTime())) return fallback;
  if (formatInTimeZone(date, TIME_ZONE, "yyyy-MM-dd") !== raw) return fallback;
  return date;
};

const paramValue = (params: URLSearchParams): string | null => {
  const exact = params.get(RISK_PICTURE_NOW_PARAM);
  if (exact) return exact;
  const name = RISK_PICTURE_NOW_PARAM.toLowerCase();
  for (const [key, value] of params) {
    if (key.toLowerCase() === name) return value;
  }
  return null;
};

/** Clock for the risk picture. `?riskPictureNow=YYYY-MM-DD` overrides it. */
export const riskPictureNow = (fallback = new Date()): Date => {
  if (typeof window === "undefined") return fallback;
  return riskPictureNowFromParam(
    paramValue(new URLSearchParams(window.location.search)),
    fallback,
  );
};
